import {MuseOn} from "./MuseOn";

export class Paragraph extends MuseOn {
  _id: string;
  title: string;
  content: string;

  constructor (data) {
    super();

    this._id = data._id;
    this.title = data.title;
    this.content = data.content;
  }

  getObj(removeNull: boolean = false) {
    const result =  {
      _id: this._id || null,
      title: this.title || '',
      content: this.content,
    };

    return removeNull
      ? this.removeNull(result)
      : result
      ;
  }
}
